// src/components/results/DownloadButton.js
import React from 'react';
import { useCalculations } from '../../context/CalculationContext';

function DownloadButton() {
  const { handleDownloadTable, isCalculating } = useCalculations();

  return (
    <button 
      className="download-button" 
      onClick={handleDownloadTable}
      disabled={isCalculating}
    >
      Download Results as CSV
    </button>
  );
}

export default DownloadButton;
